import { skeletonColor } from 'constant';

import { Flex, Skeleton } from '@chakra-ui/react';

interface FilterButtonSkeletonProps {
  isFirst?: boolean;
  bg?: string;
}
const FilterButtonSkeleton = ({
  isFirst = false,
  bg = 'white'
}: FilterButtonSkeletonProps) => (
  <Flex
    alignItems='center'
    padding='11px'
    borderLeftRadius={{ base: 0, md: '3px' }}
    borderTopLeftRadius={{ base: 0, md: isFirst ? 0 : '3px' }}
    w={{ base: 'full', md: '233px' }}
    h='65px'
    bg={bg}
    gap='11px'
  >
    <Skeleton
      borderRadius='3px'
      w={{ base: '35px', sm: '43px' }}
      h={{ base: '35px', sm: '43px' }}
      startColor={skeletonColor.start}
      endColor={skeletonColor.end}
    />

    <Flex flexDirection='column' gap={1} alignItems='flex-start' flex={1}>
      <Skeleton
        w={{ base: 'full', md: '80%' }}
        height='14px'
        variant='shine'
        startColor={skeletonColor.start}
        endColor={skeletonColor.end}
      />
      <Skeleton
        w='50%'
        height='14px'
        variant='shine'
        startColor={skeletonColor.start}
        endColor={skeletonColor.end}
      />
    </Flex>
  </Flex>
);

export default FilterButtonSkeleton;
